import { Injectable, Output, EventEmitter } from '@angular/core'

@Injectable()
export class DataTransferService {

    dataDesdeComponent

   /*  @Output() change: EventEmitter<boolean> = new EventEmitter(); */
    @Output() datos  = new EventEmitter();
    change = new EventEmitter<any>();

    newData(data) {
        this.dataDesdeComponent = data

        this.change.emit(this.dataDesdeComponent);
        this.datos.emit(this.dataDesdeComponent);
        /* console.log('cambio en storage', this.dataDesdeComponent) */
    }

    getData(): any {
        return this.dataDesdeComponent
    }

}